import styled from "styled-components";
import type { SettlementPeriod } from "../../../../api/work-policy-application-api.types";
import { workTypeDesignTokens as tokens } from "../../../work-type-shared/work-type-design-tokens";
import { formatKoreanCalendarDate } from "./calendar-date";
import {
  SelectiveApplicationFields,
  SelectiveSnapshot
} from "./selective-application-fields";
import { WorkPolicyApplicationPanel } from "./work-policy-application-panel";

interface SelectiveApplicationPanelProps {
  policyName: string;
  startDate: string;
  endDate: string;
  settlementStartDay: number | null;
  snapshot: SelectiveSnapshot;
  status: "loading" | "ready" | "error";
  periods: SettlementPeriod[];
  onRetry: () => void;
}

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${tokens.spacing.sm};

  > div {
    display: grid;
    min-width: 0;
    gap: 6px;
    padding: 12px;
    background: ${tokens.color.surfaceMuted};
    border: 1px solid ${tokens.color.border};
    border-radius: ${tokens.radius.control};
  }

  small {
    color: ${tokens.color.textMuted};
  }

  strong {
    overflow-wrap: anywhere;
    line-height: 1.45;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
  }
`;

function formatApplicationDate(value: string) {
  try {
    return formatKoreanCalendarDate(value);
  } catch {
    return "날짜 미정";
  }
}

export function SelectiveApplicationPanel({
  policyName,
  startDate,
  endDate,
  settlementStartDay,
  snapshot,
  status,
  periods,
  onRetry
}: SelectiveApplicationPanelProps) {
  return (
    <WorkPolicyApplicationPanel
      icon="clock"
      title="신청 기간의 근로시간 기준을 확인해 주세요"
      description="선택근무 정책의 정산·운영 기준은 신청기간 동안 고정 적용됩니다."
      modeLabel="선택근무"
      policyName={policyName}
      startDate={startDate}
      endDate={endDate}
    >
      <SummaryGrid>
        <div>
          <small>신청 기간</small>
          <strong>
            {formatApplicationDate(startDate)} ~ {formatApplicationDate(endDate)}
          </strong>
        </div>
        <div>
          <small>월 정산 기준</small>
          <strong>
            {settlementStartDay
              ? `${settlementStartDay}일 기준 매월`
              : "날짜 확정 후 계산"}
          </strong>
        </div>
      </SummaryGrid>
      <SelectiveApplicationFields
        snapshot={snapshot}
        status={status}
        periods={periods}
        onRetry={onRetry}
      />
    </WorkPolicyApplicationPanel>
  );
}
